
import { Component, Vue } from 'vue-property-decorator'
import StationForm from '@/components/trip/transportation/forms/generic/StationForm.vue'
import { TransportationType } from '@/utils/enums'
@Component({
  name: 'TrainForm',
  components: {
    StationForm,
  },
})
class TrainForm extends Vue {
  type: string = TransportationType.TRAIN
}
export default TrainForm
